import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { cx } from 'emotion';
import Button from '../Button';
import {
  previuosBtnLabel,
  switchItemButton,
  BackToListBtn,
  nextBtnLabel,
  ButtonGroup,
} from './styled';

const NavButtonGroup = ({
  disabledPrevious,
  previousAction,
  returnAction,
  disabledNext,
  nextAction,
  intl,
}) => (
  <ButtonGroup
    css={css`
      width: 387px;
    `}
  >
    <Button
      height="25px"
      // width="107px"
      type="secondary"
      disabled={disabledPrevious}
      clickHandler={previousAction}
      className={switchItemButton}
      css={css`
        padding: 0 12px 0 24px;
      `}
    >
      <span className={cx('prev-btn', previuosBtnLabel)}>
        {intl.formatMessage({ id: 'common.previousItem' })}
      </span>
    </Button>
    <BackToListBtn height="25px" type="secondary" clickHandler={returnAction}>
      <span>{intl.formatMessage({ id: 'common.backToList' })}</span>
    </BackToListBtn>
    <Button
      height="25px"
      // width="87px"
      type="secondary"
      disabled={disabledNext}
      clickHandler={nextAction}
      className={switchItemButton}
      css={css`
        padding: 0 24px 0 12px;
      `}
    >
      <span className={cx('next-btn', nextBtnLabel)}>
        {intl.formatMessage({ id: 'common.nextItem' })}
      </span>
    </Button>
  </ButtonGroup>
);

NavButtonGroup.propTypes = {
  disabledPrevious: PropTypes.bool.isRequired,
  disabledNext: PropTypes.bool.isRequired,
  previousAction: PropTypes.func.isRequired,
  nextAction: PropTypes.func.isRequired,
  returnAction: PropTypes.func.isRequired,
  intl: PropTypes.object,
};

export default injectIntl(NavButtonGroup);
